module.exports = __webpack_public_path__ + "static/media/img_bg_textures_gold.1865502e.png";